import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { CompleteImages } from '../../../../_global/fragments/generated/CompleteImages';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ProjectWorkspaceInfoFragment = { __typename?: 'Project', id: string, archivedAt?: string | null, fileCount: number, ignoreArchive: boolean, isWorkfront?: boolean | null, memberCount?: number | null, notificationsEnabled?: boolean | null, name: string, private: boolean, rootAssetId: string, storage: number, uniqueMemberCount?: number | null, images: { __typename?: 'Images', image32?: string | null, image64?: string | null, image128?: string | null, image256?: string | null, imageBase?: string | null, original?: string | null }, workspace?: { __typename?: 'Workspace', id: string, name: string } | null };

export const ProjectWorkspaceInfo = /*#__PURE__*/ gql`
    fragment ProjectWorkspaceInfo on Project {
  id
  archivedAt
  fileCount
  ignoreArchive
  images {
    ...CompleteImages
  }
  isWorkfront
  memberCount
  notificationsEnabled
  name
  private
  rootAssetId
  storage
  uniqueMemberCount
  workspace {
    id
    name
  }
}
    ${CompleteImages}` as unknown as DocumentNode<ProjectWorkspaceInfoFragment, unknown>;

        

        
export const useProjectWorkspaceInfoFragment = (
  input: string | Omit<UseFragmentOptions<ProjectWorkspaceInfoFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<ProjectWorkspaceInfoFragment>({
    fragment: ProjectWorkspaceInfo,
    fragmentName: 'ProjectWorkspaceInfo',
    ...options,
  });
};
  
        